import { Form, Checkbox } from '@shared/ui'
import { SRListFilterBox, SRMultiSelect } from '@sr/ui'
import { useForm, Controller } from 'react-hook-form'
import { FORM_FILTER_NAME, scheduledOptions, policyStateOptions } from './enums'
import { observer } from 'mobx-react-lite'
import { Dispatch, FC, SetStateAction, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Filter } from '@carbon/icons-react'

type FiltersProps = {
  onChangeFilters: Dispatch<SetStateAction<any>>
}

export const Filters: FC<FiltersProps> = observer(({ onChangeFilters }) => {
  const { t } = useTranslation()

  const stateOptions = policyStateOptions(t)
  const defaultPolicyStates = stateOptions
    .filter((option) => option.defaultChecked)
    .map((option) => option.value)

  const defaultValues = {
    [FORM_FILTER_NAME.subscriptionAppointment]: null,
    [FORM_FILTER_NAME.policyStates]: defaultPolicyStates,
  }
  const methods = useForm({
    defaultValues,
  })

  const { reset, watch, control } = methods

  const onClear = () => {
    reset()
  }

  const values = watch()

  useEffect(() => {
    onChangeFilters(values)
  }, [values])

  const placeHolder = (translation: string) => (
    <span className="flex items-center gap-2">
      <Filter /> {t(translation)}
    </span>
  )

  return (
    <SRListFilterBox onClear={onClear}>
      <Form methods={methods} className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <span className="text-sm font-semibold text-gray-700">
            {t('userList.filter.policyState')}
          </span>
          <div className="flex flex-col gap-2 pl-2">
            {stateOptions.map((option) => (
              <Controller
                key={option.value}
                name={FORM_FILTER_NAME.policyStates}
                control={control}
                render={({ field }) => {
                  const isChecked = field.value?.includes(option.value)
                  return (
                    <Checkbox
                      label={option.label}
                      checked={isChecked}
                      onChange={(e) => {
                        const currentValue = field.value || []
                        if (e.target.checked) {
                          field.onChange([...currentValue, option.value])
                        } else {
                          field.onChange(
                            currentValue.filter((v: number) => v !== option.value)
                          )
                        }
                      }}
                    />
                  )
                }}
              />
            ))}
          </div>
        </div>
        <SRMultiSelect
          name={FORM_FILTER_NAME.subscriptionAppointment}
          options={scheduledOptions(t)}
          placeholder={placeHolder('userList.filter.subscriptionAppointment')}
          isClearable
        />
      </Form>
    </SRListFilterBox>
  )
})
